import React, { useState } from 'react';
import { Row } from 'reactstrap';
import Dropzone from 'react-dropzone';
import EditIcon2 from 'mdi-react/SquareEditOutlineIcon';
import * as handlers from './handlers';
import { ReactComponent as TrashIcon } from 'assets/images/icons/trash.svg';
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const UploadDocument = (props) => {
  const {
    field,
    form,
    entity_type_enum,
    front_back_enum,
    fileName,
    entity_id,
    attachmentId,
    attachmentPath,
    disabled,
    isAuthorizedSignatory,
    kycStatusKey,
    setIsRenderRequired,
    setDropValues,
    company_affiliate_enum,
  } = props;

  const { name, value, onChange } = field;
  const files = value;
  const [showLightBox, setShowLightBox] = useState(false);
  const onDrop = (onDropFiles) => {
    let val = onDropFiles.map((fl) =>
      Object.assign(fl, {
        preview: URL.createObjectURL(fl),
      }),
    );

    const fileToUpload = val[val.length - 1];

    val[0] = fileToUpload;
    const attachmentIdToPass = props.attachmentId ? props.attachmentId : 0;
    const file1 = handlers.handleUpload(
      val,
      entity_type_enum,
      front_back_enum,
      entity_id,
      attachmentIdToPass,
      company_affiliate_enum,
    );
    return form.setFieldValue(name, val);
  };
  const handleDeleteUploadedDocument = async (params, e) => {
    debugger;
    await handlers.handleDeleteUploadedFileAgainstId(params);
    setIsRenderRequired && setIsRenderRequired(true);
  };

  let file_name_array = fileName?.split('.').pop();
  // console.log('upload props', props)
  return (
    <div>
      <Row>
        <div className="col-md-3">
          <Dropzone
            className="dropzone__input col-md-6"
            accept="image/jpeg, image/png, application/pdf"
            name={name}
            disabled={disabled}
            onDrop={(filesToUpload) => {
              onDrop(value ? value.concat(filesToUpload) : filesToUpload);
            }}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                {!files || files.length === 0}
                <input {...getInputProps()} />
                <div className="drag-block">
                  <Row>
                    <div className="icon-block">
                      <EditIcon2 />
                    </div>
                    <div> Drop file here</div>
                  </Row>
                </div>
              </div>
            )}
          </Dropzone>
        </div>
        {attachmentId ? (
          fileName ? (
            <div className="align-item-center">
              {file_name_array.toLowerCase() === 'pdf' ? (
                <a target="_blank" href={attachmentPath}>
                  {fileName}
                </a>
              ) : (
                <>
                  <div className="" image-file__name onClick={() => {
                    setShowLightBox(true);
                  }}>
                    <span title={fileName}>{fileName}</span>
                  </div>
                  {showLightBox && <Lightbox image={attachmentPath} onClose={() => { setShowLightBox(false) }} />}
                </>
              )}
              {isAuthorizedSignatory && !kycStatusKey && (
                <TrashIcon
                  className="cursor-pointer"
                  style={{ color: 'var(--unnamed-color-f44336)', fontSize: 'var(--fs-base__four)', marginLeft: '8px' }}
                  onClick={() => {
                    let params = {
                      attachment_id: attachmentId,
                    };
                    handleDeleteUploadedDocument(params);
                    setDropValues(0);
                  }}
                />
              )}
            </div>
          ) : (
            ''
          )
        ) : (
          ''
        )}

        {files && Array.isArray(files) && (
          <div class="row col-md-6" style={{ marginLeft: 12 }}>
            {files.map((file, i) => (
              <div key={file.i}>
                <div class="column">
                  <div class="row">{/* <p>{file.name}</p> */}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Row>
    </div>
  );
};

export default UploadDocument;
